import { Component, Input, inject, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Observable, startWith, map, firstValueFrom, catchError, Subject, Subscription } from 'rxjs';
import { AlertaService } from '../../alerta/alerta.service';
import { LoadingService } from '../../loading/loading.service';
import { iEntrada, iCatalogos, iFormasEnvio } from '../entrada.interface';
import { EntradaService } from '../entrada.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { UsuarioService } from '../../usuario/usuario.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../app.state';
import { selectCatalogos } from '../../states/catalogos/selector';
import { selectEntrada } from '../../states/entrada/selector';
import { ActivatedRoute } from '@angular/router';
import { cargaFormasEnvio } from '../../states/formas-envio/actions';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import moment from 'moment';

@Component({
  selector: 'app-add-edit-envio-ab',
  standalone: true,
  imports: [ReactiveFormsModule, 
    MatToolbarModule, 
    MatButtonModule, 
    MatIconModule, 
    MatInputModule, 
    MatFormFieldModule, 
    FormsModule, 
    MatDatepickerModule, 
    MatSelectModule,
    MatSlideToggleModule,
  ],
  providers: [
    //provideNativeDateAdapter(),
    provideMomentDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'es-MX' }
  ],
  templateUrl: './add-edit-envio-ab.component.html',
  styleUrl: './add-edit-envio-ab.component.css'
})
export class AddEditEnvioAbComponent {
  private readonly store: Store<AppState> = inject(Store);
  private readonly stateCatalogo: any = this.store.pipe(select(selectCatalogos));
  private readonly stateEntrada: any = this.store.pipe(select(selectEntrada));

  private active = inject(ActivatedRoute);
  private loadingService = inject(LoadingService);
  private entradaService = inject(EntradaService);
  private usuarioService = inject(UsuarioService);
  private alertaService = inject(AlertaService);
  private formBuilder:FormBuilder = inject(FormBuilder);
  private idEntrada = this.active.snapshot.params['id'];
  private idTema = this.active.snapshot.params['tema'];
  private subscriptions = new Subscription();

  @Input() listenToFather!: Observable<boolean>;
  @Output() sendToFather: Subject<any> = new Subject();
  
  public oEntrada: iEntrada;
  public oCatalogos: iCatalogos;
  public formEnvioAB!: FormGroup;
  public listaFormaEnvio: any = [];
  public editFormaEnvio!: any;
  public catEnvioAB: any[] = [];
  public catUsuarios: any[] = [];
  public deshabilitado: boolean = false;
  public today = new Date();
  
  constructor() {
    this.loadingService.show();

    this.formEnvioAB = this.formBuilder.group({
      tipo: ['', [Validators.required]],
      tipo_descripcion: ['', [Validators.required]],
      reunion_descripcion: [''],
      enviado: ['', [Validators.required]],
      enviado_descripcion: [''],
      fecha: ['', [Validators.required]],
      leido: [false],
      leido_fecha: [''],
      leido_hora: ['']
    });

    this.oEntrada = structuredClone(this.stateEntrada.state().entrada);
    this.oCatalogos = structuredClone(this.stateCatalogo.state().catalogos);
    this.catUsuarios = this.oCatalogos.catUsuarios;
    this.catEnvioAB = this.oCatalogos.catEnvioAB;
    
    ///////////////////////////// ONCHANGE BUSINESS RULES //////////////////////////////
    this.formEnvioAB.get('tipo')?.valueChanges.subscribe((value:any) => {
      this.businessRules('tipo', value);
    });

    this.formEnvioAB.get('enviado')?.valueChanges.subscribe((value:any) => {
      this.businessRules('enviado', value);
    });

    this.formEnvioAB.get('leido')?.valueChanges.subscribe((value:any) => {
      this.businessRules('leido', value);
    });
    ////////////////////////////////////////////////////////////////////////////////////

    this.filterUsuarios();
    this.loadingService.hide();
  }

  async ngOnInit() {
    this.idEntrada = this.active.snapshot.params['id'];
    if(this.idEntrada != 'add')
      this.listaFormaEnvio = await firstValueFrom(this.entradaService.getFormasEnvio(this.idEntrada));
    
    this.subscriptions.add(
      this.listenToFather.subscribe((oData: any) => {
        if(oData.accion == 'disabled') {
          this.deshabilitado = oData.deshabilitado;
          if(oData.deshabilitado) {
            this.formEnvioAB.disable({emitEvent: false});
          } else {
            this.formEnvioAB.enable({emitEvent: false});
          }
        }
      })
    );

    if(this.idEntrada != 'add') {
      this.deshabilitado = true;
      this.formEnvioAB.disable({emitEvent: false});
    }
    
    this.actualizaFormaEnvio();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  businessRules(type: string, value: any): void {
    if(type == 'tipo') {
      const tipo_descripcion = (value !== 'otro')?this.catEnvioAB.filter((item: any) => { return item.id == value })[0].descripcion:'';
      this.formEnvioAB.get('tipo_descripcion')?.setValue(tipo_descripcion);

      if(value == '-LLe6-mlTJn4XMIQhm9Z') {
        this.formEnvioAB.get('reunion_descripcion')?.setValidators([Validators.required]);
      }
      if(value == 'otro') {
        this.formEnvioAB.get('tipo_descripcion')?.setValue('');
      }

      if(value !== '-LLe6-mlTJn4XMIQhm9Z') {
        this.formEnvioAB.get('reunion_descripcion')?.setValue('');
        this.formEnvioAB.get('reunion_descripcion')?.clearValidators();
        this.formEnvioAB.get('reunion_descripcion')?.setErrors(null); 
      }

      this.formEnvioAB.get('reunion_descripcion')?.updateValueAndValidity();
    }

    if(type == 'enviado') {
      const enviado = this.catUsuarios.filter((item: any) => { return item.id == value })[0];
      this.formEnvioAB.get('enviado_descripcion')?.setValue(`${enviado.nombre} | ${enviado.mail}`);
    }
    
    if(type == 'leido') {
      if(value) {
        this.formEnvioAB.get('leido_fecha')?.setValidators([Validators.required]);
        this.formEnvioAB.get('leido_hora')?.setValidators([Validators.required]);
      } else {
        this.formEnvioAB.get('leido_fecha')?.setValue('');
        this.formEnvioAB.get('leido_fecha')?.clearValidators();
        this.formEnvioAB.get('leido_fecha')?.setErrors(null); 

        this.formEnvioAB.get('leido_hora')?.setValue('');
        this.formEnvioAB.get('leido_hora')?.clearValidators();
        this.formEnvioAB.get('leido_hora')?.setErrors(null);   
      }

      this.formEnvioAB.get('leido_fecha')?.updateValueAndValidity();
      this.formEnvioAB.get('leido_hora')?.updateValueAndValidity();
    }
  }

  edit(index: number, item: any) {
    this.editFormaEnvio = {index: index, ...item};

    this.formEnvioAB.patchValue({
      tipo: item.tipo,
      tipo_descripcion: item.tipo_descripcion,
      reunion_descripcion: item.reunion_descripcion,
      enviado: item.enviado,
      enviado_descripcion: item.enviado_descripcion,
      fecha: moment(item.fecha, "YYYY-MM-DD").toDate(),
      leido: item.leido,
      leido_fecha: moment(item.leido_fecha, "YYYY-MM-DD").toDate(),
      leido_hora: item.leido_hora
    });
  }

  delete(index: number, item: any) {
    const dialogRef = this.alertaService.confirm({
      title: `¿Le gustaría eliminar ${item.tipo_descripcion}?`,
      description: 'Esta acción es permanente.', 
      index: index, 
      item: item
    });

    dialogRef.afterClosed().subscribe((result:any) => {
      if(!result) return;

      this.listaFormaEnvio.splice(result.index, 1);
      this.actualizaFormaEnvio()

      if(item.entrada && item.id) {
        this.entradaService.delFormasEnvio(item.entrada, item.id);
      }
    });
  }

  resetForm() {
    this.editFormaEnvio = null;
    this.formEnvioAB.reset(null,{emitEvent:false});
    this.businessRules('leido', false);
  }

  save() {
    if (this.formEnvioAB.valid) {
      let formaEnvio: any = this.formEnvioAB.value;
      formaEnvio.fecha = moment(formaEnvio.fecha).format("YYYY-MM-DD");
      formaEnvio.leido_fecha = (formaEnvio.leido)? moment(formaEnvio.leido_fecha).format("YYYY-MM-DD") : "";
      
      if(this.editFormaEnvio) {
        const updateFormaEnvio = {...this.editFormaEnvio, ...formaEnvio};
        this.listaFormaEnvio[this.editFormaEnvio.index] = updateFormaEnvio;
      } else {
        this.listaFormaEnvio.push(formaEnvio);
      }

      this.resetForm();
      this.actualizaFormaEnvio();
    }
  }

  actualizaFormaEnvio() {
    const catUse = this.listaFormaEnvio.map((item:any) => item.tipo);
    this.catEnvioAB.map((item: any) => {
      item.use = false;
      if(catUse.includes(item.id)) 
        item.use = true;
    });

    const oFormasEnvio = structuredClone(this.listaFormaEnvio);
    this.store.dispatch(cargaFormasEnvio({ oFormasEnvio }));
  }

  filterUsuarios() {
    this.catUsuarios = this.catUsuarios.filter((item: any) => {
      item.filterFormaEnvio = false;
      if(item.mostrar === true) {
        if(item.rol == 1) {
            item.filterFormaEnvio = (item.formaEnvio !== undefined)?item.formaEnvio:false;
        } else {
            item.filterFormaEnvio = true;
        }
      }

      return item.activo && item.filterFormaEnvio && item.rol !== 4;
    });
  }
}